import { WebStorageStateStore, InMemoryWebStorage } from 'oidc-client-ts';

export const getOidcConfig = () => {
    return {
        client_id: 'project-approval-client',
        redirect_uri: `${window.location.origin}/`,
        silent_redirect_uri: `${window.location.origin}/login/callback`,
        scope: 'openid profile email',
        userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() })
    };
};